<div class="global-search" [class.has-query]="term" [class.is-open]="open">
  <i class="pi pi-search"></i>
  <input #globalSearchInput type="text" [value]="term" (input)="termChange.emit(globalSearchInput.value)"
    (focus)="opened.emit()" (blur)="blurred.emit()" (keydown)="keydownSearch.emit($event)"
    [placeholder]="'search.placeholder' | transloco" [attr.aria-label]="'search.label' | transloco" />
  @if (loading) {
  <span class="global-search-loading" [attr.aria-label]="'search.searching' | transloco">
    <i class="pi pi-spin pi-spinner"></i>
  </span>
  }
  @if (term) {
  <button type="button" class="search-clear" [attr.aria-label]="'search.clear' | transloco" (mousedown)="$event.preventDefault()"
    (click)="cleared.emit()">
    <i class="pi pi-times"></i>
  </button>
  }

  @if (open && term.trim()) {
  <div class="global-search-panel" role="listbox" [attr.aria-label]="'search.matches' | transloco">
    @if (loading) {
    <div class="global-search-status">
      <i class="pi pi-spin pi-spinner"></i>
      <span>{{ 'search.searchingRecords' | transloco }}</span>
    </div>
    }
    @for (group of groups; track trackGroup($index, group)) {
    <section class="global-search-group">
      <div class="global-search-group-label">{{ group.label }}</div>
      @for (result of group.results; track result.id + result.route) {
      <button type="button" class="global-search-result" [class.active]="isResultActive(result)"
        (mousedown)="$event.preventDefault()" (click)="resultSelected.emit(result)">
        <i [class]="'global-search-result-icon ' + result.icon"></i>
        <span class="global-search-result-copy">
          <span class="global-search-result-label">{{ result.label }}</span>
          <span class="global-search-result-meta">
            {{ result.subtitle }}
            <span class="global-search-result-route">{{ result.route }}</span>
          </span>
        </span>
      </button>
      }
    </section>
    } @empty {
    <div class="global-search-empty">{{ loading ? ('search.searchingEllipsis' | transloco) : ('search.noMatches' | transloco) }}</div>
    }
  </div>
  }
</div>
